import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6 font-sans">
      <div className="max-w-lg w-full bg-[#111315] border border-white/10 p-10 text-center" data-testid="payment-cancel-page">
        <XCircle className="w-14 h-14 text-[#FF3B30] mx-auto mb-6" />
        <h1 className="text-2xl font-black uppercase tracking-tight mb-2">Checkout Cancelled</h1>
        <p className="text-[#8E8E93] text-sm leading-relaxed mb-6">
          No payment was taken. Your license was not activated. You can resume anytime from the pricing section.
        </p>
        <Link
          to="/#pricing"
          className="inline-flex items-center gap-2 border border-white/20 hover:border-white hover:bg-white hover:text-black px-6 py-3 text-xs font-mono uppercase tracking-wider transition-colors"
          data-testid="payment-cancel-home-link"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Pricing
        </Link>
      </div>
    </div>
  );
}
